/*
 * Application Insights JavaScript SDK - Common, 2.7.0
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
import { __extendsFn as __extends } from "@microsoft/applicationinsights-shims"; // THIS FILE WAS AUTOGENERATED

import { Base } from './Base';
/**
 * Data struct to contain both B and C sections.
 */

var Data =
/** @class */
function (_super) {
  __extends(Data, _super);

  function Data() {
    return _super.call(this) || this;
  }

  return Data;
}(Base);

export { Data };